import { render, staticRenderFns } from "./MToast.vue?vue&type=template&id=065750bc&scoped=true"
import script from "./MToast.vue?vue&type=script&lang=js"
export * from "./MToast.vue?vue&type=script&lang=js"
import style0 from "./MToast.vue?vue&type=style&index=0&id=065750bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065750bc",
  null
  
)

export default component.exports